import { render, staticRenderFns } from "./NovaClose.vue?vue&type=template&id=a8fbdb60&"
import script from "./NovaClose.vue?vue&type=script&lang=js&"
export * from "./NovaClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports